export enum IcePieRangesColorCodesEnum {
    RANGE_100 = '#00b050',
    RANGE_80_99 = '#c4d6a0',
    RANGE_60_79 = '#ffff99',
    RANGE_40_59 = '#ffcc99',
    RANGE_20_39 = '#ff8080',
    RANGE_0_19 = '#ff0000',
}

export enum IcePieRangesColorCodesEnumMeetingRoomScoresByListings {
    RANGE_100 = '#00af4e',
    RANGE_80_99 = '#c3d69e',
    RANGE_60_79 = '#fdfe98',
    RANGE_40_59 = '#ffcb99',
    RANGE_20_39 = '#fe8081',
    RANGE_0_19 = '#fd0000',
}
